<template>
  <div class="d-flex justify-center">
    <v-card
      :width="mobile ? '80%' : '55%'"
      max-height="78vh"
      elevation="4"
      class="d-flex flex-column"
    >
        <v-card-title class="text-h5 text-center font-weight-bold py-4">
        Relatório de Vendas/Compras
        </v-card-title>

        <v-card-subtitle class="text-center mb-4">
        Selecione os filtros para gerar o relatório
        </v-card-subtitle>

        <v-divider />

        <v-card-text class="card-scroll">
            <v-form ref="form">
                <v-row class="mt-2" justify="center" dense>
                    <v-col cols="12" md="8">
                        <BaseAutoComplete
                            v-model="customer.customerId"
                            store-module="customer"
                            items-state="lstCustomer"
                            :item-title="item => `${item.customerId} - ${item.customerName}`"
                            item-value="customerId"
                            action="search"
                            label="Cliente"
                            density="comfortable"
                            prepend-inner-icon="mdi-account"
                        />
                    </v-col>
                    <v-col cols="12" md="8">
                        <BaseAutoComplete
                            v-model="seller.sellerId"
                            store-module="seller"
                            items-state="lstSeller"
                            :item-title="item => `${item.sellerId} - ${item.sellerName}`"
                            item-value="sellerId"
                            action="search"
                            label="Vendedor"
                            density="comfortable"
                            prepend-inner-icon="mdi-account-tie"
                        />
                    </v-col>
                    <v-col cols="12" md="8">
                        <BaseAutoComplete
                            v-model="product.productId"
                            store-module="product"
                            items-state="lstProduct"
                            :item-title="item => `${item.productId} - ${item.productName}`"
                            item-value="productId"
                            action="search"
                            label="Produto"
                            density="comfortable"
                            prepend-inner-icon="mdi-account-tie"
                        />
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols=12 md="4">
                        <v-menu
                            v-model="initialMenu"
                            :close-on-content-click="false"
                            persistent
                            >
                            <template #activator="{ props }">
                                <v-text-field
                                    v-bind="props"
                                    v-model="initialDateFormatted"
                                    label="Data Inicial"
                                    prepend-inner-icon="mdi-calendar"
                                    variant="outlined"
                                    readonly
                                    rounded
                                    density="comfortable"
                                />
                            </template>
    
                            <v-date-picker
                                v-model="initialDate"
                                :max="finalDate"
                                @update:model-value="onInitialDateSelected"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols=12 md="4">
                        <v-menu
                            v-model="finalMenu"
                            :close-on-content-click="false"
                            persistent
                            >
                            <template #activator="{ props }">
                                <v-text-field
                                    v-bind="props"
                                    v-model="finalDateFormatted"
                                    label="Data Final"
                                    prepend-inner-icon="mdi-calendar"
                                    variant="outlined"
                                    readonly
                                    rounded
                                    density="comfortable"
                                />
                            </template>
    
                            <v-date-picker
                                v-model="finalDate"
                                :min="initialDate"
                                @update:model-value="onFinalDateSelected"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols="12 ml-5">
                        <v-radio-group v-model="operation" inline color="primary" class="d-flex justify-center">
                            <v-radio label="Venda" :value="OperationType.Venda" />
                            <v-radio label="Compra" :value="OperationType.Compra" />
                            <v-radio label="Ambos" :value="OperationType.Ambos" />
                        </v-radio-group>
                    </v-col>
                </v-row>
    
                <v-row class="mt-6 mb-4" justify="center">
                    <v-col cols="12" class="d-flex justify-center">
                        <v-btn
                            color="primary"
                            rounded
                            @click="generateRelat()"
                        >
                            Gerar relatório
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { OperationType } from '@/enums/operationType';
import BaseAutoComplete from '@/components/BaseAutoComplete.vue';
import { useDisplay } from 'vuetify'

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
        OperationType,
        initialMenu: false,
        finalMenu: false,
        initialDate: null,
        finalDate: null,
        initialDateFormatted: '',
        finalDateFormatted: '',
        operation: OperationType.Venda
    }),
    components: {
        BaseAutoComplete
    },
    computed: {
        customer: {
            get() {
                return this.$store.state.customer
            },
        },
        seller: {
            get() {
                return this.$store.state.seller
            },
        },
        product: {
            get() {
                return this.$store.state.product
            },
        },
    },
    methods: {
        async generateRelat() {
            const { valid } = await this.$refs.form.validate()

            if (!valid) return
            
            await this.$store.dispatch('relats/downloadCustomerHistoryReport', { 
                customerId: this.customer.customerId, 
                initialDate: this.initialDate, 
                finalDate: this.finalDate,
                sellerId: this.seller.sellerId,
                productId: this.product.productId,
                operation: this.operation,
            })
        },
        onInitialDateSelected(val) {
            this.initialDate = val
            this.initialDateFormatted = new Date(val).toLocaleDateString('pt-BR')
            this.initialMenu = false
        },
        onFinalDateSelected(val) {
            this.finalDate = val
            this.finalDateFormatted = new Date(val).toLocaleDateString('pt-BR')
            this.finalMenu = false
        }
    },
    async mounted() {
        this.customer.customerId = null
        this.initialDate = ''
        this.finalDate = ''
        this.seller.sellerId = null
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>